import { Injectable, signal } from '@angular/core';
import { ActiveLocationsSummaryView } from '../contract/active-location.contract';

@Injectable({ providedIn: 'root' })
export class ActiveLocationsSummaryService {
  $dataSummary = signal<ActiveLocationsSummaryView | null>(null);
}
